import type { PrimeVueConfiguration } from 'primevue/config'
import buttonPt from '@lib/pt/button'
import checkboxPt from '@lib/pt/checkbox'
import datePickerPt from '@lib/pt/date-picker'
import inputTextPt from '@lib/pt/input-text'
import selectPt from '@lib/pt/select'
import multiSelectPt from '@lib/pt/multi-select'
import dataTablePt from '@lib/pt/data-table'
import dialogPt from '@lib/pt/dialog'
import toastPt from '@lib/pt/toast'

export const csLocale = {
    accept: 'Ano',
    reject: 'Ne',
    choose: 'Vybrat',
    upload: 'Nahrát',
    cancel: 'Zrušit',
    clear: 'Vymazat',
    apply: 'Použít',
    emptyMessage: 'Nic nenalezeno',
    emptySearchMessage: 'Nic nenalezeno',
    dayNames: ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota'],
    dayNamesShort: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
    dayNamesMin: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
    monthNames: [
        'leden',
        'únor',
        'březen',
        'duben',
        'květen',
        'červen',
        'červenec',
        'srpen',
        'září',
        'říjen',
        'listopad',
        'prosinec'
    ],
    monthNamesShort: ['led', 'úno', 'bře', 'dub', 'kvě', 'čvn', 'čvc', 'srp', 'zář', 'říj', 'lis', 'pro'],
    firstDayOfWeek: 1,
    today: 'Dnes',
    weekHeader: 'Tý'
}

export const enLocale = {
    accept: 'Yes',
    reject: 'No',
    choose: 'Choose',
    upload: 'Upload',
    cancel: 'Cancel',
    clear: 'Clear',
    apply: 'Apply',
    emptyMessage: 'No results',
    emptySearchMessage: 'No results',
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    monthNames: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    firstDayOfWeek: 1,
    today: 'Today',
    weekHeader: 'Wk'
}

export const primevueOptions = {
    unstyled: true,
    pt: {
        button: buttonPt,
        checkbox: checkboxPt,
        datepicker: datePickerPt,
        inputtext: inputTextPt,
        select: selectPt,
        multiselect: multiSelectPt,
        datatable: dataTablePt,
        dialog: dialogPt,
        toast: toastPt
    },
    ptOptions: { mergeProps: true },
    locale: csLocale
} as PrimeVueConfiguration
